import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { map, filter } from 'rxjs/operators';
import { SdNavService } from '../sd-nav.service';
import { untilViewDestroyed } from '@sd-portal/shared/rxjs';
import {AnalyticsService} from "@sd-portal/shared/util";

@Component({
  selector: 'sd-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AnalyticsService]
})
export class SideNavComponent implements OnInit, OnDestroy {
  routes$ = this.navService.getRoutes().pipe(untilViewDestroyed(this));
  currentPath$ = this.router.events.pipe(
    untilViewDestroyed(this),
    filter(event => event instanceof NavigationEnd),
    map(_ => this.location.path())
  );

  constructor(
    private readonly location: Location,
    private readonly router: Router,
    private readonly navService: SdNavService,
    private readonly analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}
  ngOnDestroy() {}
  sendClickEvent(buttonName: string) {
    this.analyticsService.clickButton(buttonName)
  }
}
